import axios from "axios";
import { getData } from "../contexts/authContext";

export const getElegibleEvents = async (
  endDate: string,
  startDate: string,
  patientName?: string
) => {
  const token = await getData("idToken");
  let url = `${process.env.REACT_APP_BASE_URL}/elegible-event?startDate=${startDate}&endDate=${endDate}`;
  if (patientName) {
    url = `${url}&patientName=${patientName}`;
  }
  const { data } = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};
